var React = require('react');
var Input = require('./../../input');
var Range = require('./../../range_input');
var Color = require('./../../color_input');

var createReactClass = require('create-react-class');
module.exports = createReactClass({

  displayName: 'BackgroundControls',

  render : function () {
    return (
      <div className="customization-controls">
        <Input
          label="Background Image"
          name="background_image"
          type="text"
          defaultValue={this.props.background_image}
          onChange={this.props.onChange.bind(null, 'background_image')} />
        <Color
          label="Primary Text Color"
          name="primary_text_color"
          defaultValue={this.props.primary_text_color}
          onChange={this.props.onChange.bind(null, 'primary_text_color')} />
        <Color
          label="Secondary Text Color"
          name="secondary_text_color"
          defaultValue={this.props.secondary_text_color}
          onChange={this.props.onChange.bind(null, 'secondary_text_color')} />
        <Color
          label="Button Color"
          name="button_color"
          defaultValue={this.props.button_color}
          onChange={this.props.onChange.bind(null, 'button_color')} />
        <Color
          label="Button Text Color"
          name="button_text_color"
          defaultValue={this.props.button_text_color}
          onChange={this.props.onChange.bind(null, 'button_text_color')} />
        <Color
          label="Shadow Color"
          name="shadow_color"
          defaultValue={this.props.shadow_color}
          onChange={this.props.onChange.bind(null, 'shadow_color')} />
        <Range
          label="Shadow Distance"
          min="1"
          max="75"
          defaultValue={this.props.shadow_distance}
          onChange={this.props.onChange.bind(null, 'shadow_distance')} />
      </div>
    )
  }

});



// WEBPACK FOOTER //
// ./app/assets/javascripts/components/better_error_pages/controls/background.jsx